import * as moment from 'moment';
import TicketType from '../models/ticket.type';

export function getSoonerDate(
  ticketTypes: TicketType[],
  eventStartAt?: string | Date
) {
  if (!eventStartAt) {
    return '';
  }

  if (!ticketTypes.length) {
    return eventStartAt;
  }

  const selectedWithStartOns = ticketTypes.filter((s) => s.start_on);
  if (selectedWithStartOns.length === 0) return eventStartAt;

  let sooner = new Date(selectedWithStartOns[0].start_on);
  for (const tt of selectedWithStartOns.slice(1)) {
    if (moment(tt.start_on).isSameOrBefore(sooner)) {
      sooner = new Date(tt.start_on);
    }
  }

  return sooner?.toISOString();
}
